import LOG from './log';

export default function() {
  const environment = window.location.href.match(
    /http(s?):\/\/[a-z-]{1,}-(dev|hlg|site)(\.paywall-wrs-hlg)?\.(clicrbs|rbs)\.com\.br(:([0-9]{1,}))?/g
  )
    ? 'development'
    : 'production';

  LOG('[environment]', environment);

  return environment;
}
